{
	"title": "Locaties",
	"description": "Waar de voorraad ligt. Eén locatie is de standaard: daar komt voorraad terecht als je niets kiest.",
	"empty": "Er zijn geen locaties.",
	"column": {
		"name": "Naam",
		"quantity": "Voorraad",
		"created": "Toegevoegd",
		"actions": "Acties"
	},
	"default": "Standaard",
	"field": {
		"name": "Naam",
		"nameDescription": "Bijvoorbeeld “Magazijn Utrecht”. Zo zie je de locatie terug bij de voorraad."
	},
	"new": {
		"title": "Locatie toevoegen",
		"submit": "Toevoegen"
	},
	"rename": {
		"button": "{{name}} hernoemen",
		"label": "Nieuwe naam voor {{name}}",
		"save": "Opslaan",
		"cancel": "Annuleren"
	},
	"remove": {
		"button": "{{name}} deactiveren",
		"title": "{{name}} deactiveren?",
		"description": "De locatie verdwijnt uit de voorraad en de keuzelijsten. De historie blijft bewaard.",
		"confirm": "Deactiveren",
		"default": "De standaardlocatie blijft altijd bestaan.",
		"hasStock": "Er ligt nog voorraad: boek die eerst over of corrigeer naar 0."
	},
	"error": {
		"nameTaken": "Er is al een locatie met deze naam.",
		"notFound": "Deze locatie bestaat niet (meer)."
	},
	"help": {
		"location": {
			"title": "Locatie",
			"area": "Instellingen › Locaties",
			"short": "Een plek waar voorraad ligt, zoals het magazijn. Voorraad is altijd per variant per locatie. Op de standaardlocatie komt voorraad terecht als je geen locatie kiest. Met meer locaties krijgt de voorraadlijst een kolom per locatie.",
			"warning": "Een locatie met voorraad kun je niet deactiveren: boek die eerst over of corrigeer naar 0. De standaardlocatie blijft altijd. De historie blijft bewaard.",
			"terms": ["location:add"],
			"goTo": {
				"to": "/settings/location",
				"label": "Naar Locaties"
			}
		},
		"add": {
			"title": "Locatie toevoegen",
			"area": "Instellingen › Locaties",
			"short": "Een nieuwe locatie begint zonder voorraad. Bij Voorraad zet je er iets op, met een ontvangst of een overboeking vanaf een andere locatie.",
			"goTo": {
				"to": "/stock",
				"label": "Naar Voorraad"
			}
		}
	}
}
